import { render, staticRenderFns } from "./scene6.vue?vue&type=template&id=797ccbbc&scoped=true&"
import script from "./scene6.vue?vue&type=script&lang=ts&"
export * from "./scene6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ccbbc",
  null
  
)

export default component.exports